import type { ITabsSummary, Certificates, CertificateScanHistoryData } from './model'
import { ActionType } from './model'

import type { CertificateCustomer, PreviewPublicCertificateProps } from 'types'

import createReducer from '../createReducer'
import { Action, Nullable } from '../model'

export interface ICertificatesReducer {
  certificates: Certificates | null
  certificate: Nullable<CertificateCustomer>
  certificateScanHistory: Nullable<CertificateScanHistoryData>
  tabsSummary: Nullable<ITabsSummary[]>
  previewPublicCertificateData: PreviewPublicCertificateProps | null
}

const defaultState: ICertificatesReducer = {
  certificates: null,
  certificate: null,
  certificateScanHistory: null,
  tabsSummary: null,
  previewPublicCertificateData: null,
}

export const certificatesReducer = createReducer<ICertificatesReducer>(defaultState, {

  [ActionType.SET_CERTIFICATE]: (
    state: Nullable<ICertificatesReducer>,
    action: Action<Nullable<CertificateCustomer>>
  ) => ({
    ...state,
    certificate: action.payload,
  }),

  [ActionType.SET_CERTIFICATE_SCAN_HISTORY]: (
    state: Nullable<ICertificatesReducer>,
    action: Action<Nullable<unknown>>
  ) => ({
    ...state,
    certificateScanHistory: action.payload,
  }),

  [ActionType.SET_TABSSUMMARY]: (state: Nullable<ICertificatesReducer>, action: Action<Nullable<ITabsSummary[]>>) => ({
    ...state,
    tabsSummary: action.payload,
  }),

  [ActionType.PREVIEW_PUBLIC_CERTIFICATE]: (
    state: Nullable<ICertificatesReducer>,
    action: Action<Nullable<PreviewPublicCertificateProps>>
  ) => ({
    ...state,
    previewPublicCertificateData: action.payload,
  }),
})
